import { formatMessage } from '@99designs/frontend-components/i18n';
import { CurrencyCode } from '@99designs/i18n';
import { toUnit } from '@99designs/spa-common';

type MarketingKey =
    | 'logo-brand-guide'
    | 'logo-brand-identity-pack'
    | 'logo-business-card-design'
    | 'logo-design'
    | 'logo-website-squarespace'
    | 'logo-social-media-pack'
    | 'brand-starter-pack'
    | 'brand-launch-pack';

export const roundAmountInCentsToWholeAmount = (amountInCents: number, currency: CurrencyCode) => {
    return Math.round(toUnit(amountInCents, currency));
};

export const getFormattedPrice = (amount: number, currency: string, locale: string) => {
    locale = locale.replace('_', '-');
    return Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
    }).format(amount);
};

export function getSavings(categoryKey: MarketingKey, currencyCode: CurrencyCode, locale: string) {
    const savingsAmount = categoryKey
        ? getSavingsAmountInCents(categoryKey as MarketingKey, currencyCode)
        : undefined;

    const saving = savingsAmount
        ? formatMessage(__('Save {price}'), {
              price:
                  typeof savingsAmount === 'number'
                      ? getFormattedPrice(
                            roundAmountInCentsToWholeAmount(savingsAmount, currencyCode),
                            currencyCode,
                            locale
                        )
                      : savingsAmount,
          })
        : undefined;
    return saving;
}

type SavingsAmount = {
    [key in MarketingKey]: { [key in CurrencyCode]: number | string };
};
// TODO - Duplicating the Code from feature-product-details to avoid interdependency
// this will be discused and refactored in the engineering cycle

const getSavingsAmountInCents = (
    marketingKey: MarketingKey,
    currency: CurrencyCode
): number | string | undefined => {
    const savingsAmounts: Partial<SavingsAmount> = {
        'logo-brand-guide': {
            AUD: 8900,
            CAD: 9900,
            CHF: 7900,
            DKK: 49900,
            EUR: 5900,
            GBP: 5900,
            HKD: 49900,
            JPY: 7599,
            MXN: 129900,
            NOK: 59900,
            SGD: 10900,
            USD: 7000,
        },
        'logo-business-card-design': {
            AUD: 6900,
            CAD: 6900,
            CHF: 5900,
            DKK: 39900,
            EUR: 3900,
            GBP: 3900,
            HKD: 39900,
            JPY: 5199,
            MXN: 99900,
            NOK: 49900,
            SGD: 6900,
            USD: 4900,
        },
        'logo-social-media-pack': {
            AUD: 18700,
            CAD: 19700,
            CHF: 13700,
            DKK: 91700,
            EUR: 11700,
            GBP: 9700,
            HKD: 111700,
            JPY: 14697,
            MXN: 259700,
            NOK: 116700,
            SGD: 18700,
            USD: 13700,
        },
        'logo-brand-identity-pack': {
            AUD: '39%+',
            CAD: '39%+',
            CHF: '39%+',
            DKK: '39%+',
            EUR: '37%+',
            GBP: '39%+',
            HKD: '37%+',
            JPY: '39%+',
            MXN: '39%+',
            NOK: '39%+',
            SGD: '38%+',
            USD: '39%+',
        },
        'brand-starter-pack': {
            AUD: 0,
            CAD: 0,
            CHF: 0,
            DKK: 0,
            EUR: 0,
            GBP: 0,
            HKD: 0,
            JPY: 0,
            MXN: 0,
            NOK: 0,
            SGD: 0,
            USD: '20%+',
        },
        'brand-launch-pack': {
            AUD: 0,
            CAD: 0,
            CHF: 0,
            DKK: 0,
            EUR: 0,
            GBP: 0,
            HKD: 0,
            JPY: 0,
            MXN: 0,
            NOK: 0,
            SGD: 0,
            USD: '35%+',
        },
    };

    return savingsAmounts?.[marketingKey]?.[currency];
};
